import { TextField, Typography } from "@material-ui/core";
import React from "react";
import { useForm } from "react-hook-form";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import ButtonWithStyle from "../../../HOCs/ButtonWithStyle/ButtonWithStyle";

const LevelToUserForm = ({ user, updateUserLevel, cancelSubmit }) => {
	const { register, handleSubmit } = useForm();
	const levels = [
		["classic", "Clásico"],
		["silver", "Plata"],
		["gold", "Oro"],
		["platinum", "Platinum"],
	];

	const callback = ({ user, level, loyaltyPoints }) => {
		alert(`Se actualizó con exito el nivel de ${user} a ${level} con ${loyaltyPoints} puntos`);
	};

	const onSubmit = ({ level, loyaltyPoints }) => {
		const mail = user.mail;
		if (!window.confirm(`Desea asignar este nivel a ${mail}`)) return;
		updateUserLevel({ id: user.id, level, loyaltyPoints }, () => callback({ user: mail, level, loyaltyPoints }));
	};

	return (
		<div>
			<Typography variant="body2">
				Actualizando nivel de {user.mail} actualmente nivel {user.level}
			</Typography>
			<TextField
				style={{ width: "200px", margin: "1em" }}
				select
				SelectProps={{
					native: true,
					IconComponent: () => <ArrowDropDownIcon />,
				}}
				name="level"
				label="Nivel nuevo"
				inputRef={register({ required: true })}
			>
				{levels.map(([level, name]) => (
					<option key={level} value={level}>
						{name}
					</option>
				))}
			</TextField>
			<TextField
				style={{ width: "200px", margin: "1em" }}
				name="loyaltyPoints"
				label="Puntos de usuario"
				type="number"
				inputRef={register({ required: true })}
			/>
			<br />
			<ButtonWithStyle style={{ backgroundColor: "gray" }} onClick={cancelSubmit}>
				Cancelar
			</ButtonWithStyle>
			<ButtonWithStyle onClick={handleSubmit(onSubmit)}> Guardar </ButtonWithStyle>
		</div>
	);
};

export default LevelToUserForm;
